// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg fill=%27gray%27 height=%2720%27 viewBox=%270 0 20 20%27 width=%2720%27 xmlns=%27http://www.w3.org/2000/svg%27><path d=%27M5.516 7.548l4.484 4.484 4.484-4.484L16 8.548l-6 6-6-6z%27/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.allchats-container {
  display: flex;
  height: 100vh;
  background: #f8f9fa;
  overflow: hidden;
}

.allchats-sidebar {
  width: 300px;
  padding: 20px;
  position: relative; /* create stacking context */
  overflow-y: auto; /* whole sidebar scrolls; pager flows right after the list */
  background: linear-gradient(180deg, #232e47, #111733); /* match landing page left panel */
  color: #ffffff;
}

.allchats-sidebar h4 {
  margin-bottom: 20px;
  font-size: 14px;
  font-weight: 600;
  color: #ffffff;
}

/* Pagination — flows immediately after the list of builds. */
.chat-pagination {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 6px;
  padding-top: 12px;
  margin-top: 10px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}

.page-btn {
  width: 28px;
  height: 28px;
  padding: 0;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.25);
  background: rgba(255, 255, 255, 0.08);
  color: #e5e7eb;
  font-size: 12px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s, border-color 0.15s, color 0.15s;
}

.page-btn:hover:not(:disabled) {
  background: #6366f1;
  border-color: #6366f1;
  color: #ffffff;
}

.page-btn.active {
  background: #d1a054; /* gold accent (matches sidebar spinner) */
  border-color: #d1a054;
  color: #1a1a1a;
  font-weight: 700;
}

.page-btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.page-arrow {
  font-size: 16px;
}

.page-ellipsis {
  color: #cbd5e1;
  padding: 0 2px;
  font-size: 13px;
  -webkit-user-select: none;
          user-select: none;
}

.chat-item {
  position: relative;
  margin-bottom: 12px;
  padding: 10px 14px;
  border-radius: 12px;
  background: #ffffff;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
  transition: box-shadow 0.15s, background 0.15s; /* removed transform */
  z-index: auto;
}

.chat-item:hover {
  background: #e0e7ff;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12); /* keep only shadow, no transform */
}

.chat-item.selected {
  background: #c7d2fe;
  border: 1px solid #6366f1;
}

.chat-main {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
  color: #1e293b;
}

.pin-icon {
  margin-right: 6px;
  font-size: 14px;
}

.chat-options-btn {
  /* background: #e0e0e0; */
  border: none;
  cursor: pointer;
  width: 24px;
  height: 24px;
  border-radius: 6px;
  font-size: 16px;
  line-height: 1;
}

/* CHAT DROPDOWN */
.chat-dropdown {
  position: absolute;
  top: 38px;
  right: 0;
  width: 200px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 16px 32px rgba(0, 0, 0, 0.15);
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  z-index: 9999; /* high z-index */
}

.chat-dropdown button {
  background: #f1f5f9;
  color: #1e293b;
  border: none;
  padding: 6px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 13px;
  text-align: left;
  transition: background 0.15s;
}

.chat-dropdown button:hover {
  background: #e0e7ff;
}

.rename-input-container {
  display: flex;
  gap: 6px;
}

.rename-input-container input {
  flex: 1 1;
  padding: 6px 8px;
  border-radius: 8px;
  border: 1px solid #cbd5e1;
  font-size: 13px;
}

.rename-input-container button {
  padding: 6px 8px;
  border-radius: 8px;
  border: none;
  background: #6366f1;
  color: white;
  cursor: pointer;
}

.allchats-main {
  flex: 1 1;
  padding: 20px;
  overflow-y: auto;
}
.allchats-main h2 {
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: 600;
  color: #0f172a;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content {
  background: white;
  padding: 25px;
  border-radius: 8px;
  width: 400px;
  text-align: center;
}

.primary-btn {
  background: #007bff;
  color: white;
  padding: 10px 18px;
  border-radius: 6px;
  margin: 10px;
}

.secondary-btn {
  background: #ccc;
  padding: 10px 18px;
  border-radius: 6px;
  margin: 10px;
}

/* Dropdown styling */
.share-user-select {
  width: 100%;
  padding: 12px 14px;
  border-radius: 8px;
  border: 1px solid #d0d7de;
  background: #fff;
  font-size: 15px;
  color: #333;
  margin: 15px 0;
  transition: all 0.2s ease;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 12px center;
}

.share-user-select:hover {
  border-color: #b6bec7;
}

.share-user-select:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25);
}

/* Button container */
.share-modal-buttons {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 20px;
}

/* Primary button */
.btn-primary {
  background: #007bff;
  color: white;
  padding: 10px 22px;
  border-radius: 6px;
  border: none;
  font-size: 15px;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.1s ease;
}

.btn-primary:hover {
  background: #0069d9;
  transform: translateY(-1px);
}

.btn-primary:disabled {
  background: #a8c8f0;
  cursor: not-allowed;
}

/* Secondary button */
.btn-secondary {
  background: #e4e7eb;
  color: #333;
  padding: 10px 22px;
  border-radius: 6px;
  border: none;
  font-size: 15px;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.1s ease;
}

.btn-secondary:hover {
  background: #d4d7db;
  transform: translateY(-1px);
}


.btn-approve {
  background: #0a62c0;
  color: white;
  padding: 10px 22px;
  border-radius: 6px;
  border: none;
  font-size: 15px;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.1s ease;
}

.btn-approve:hover {
  background: #0254ac;
  transform: translateY(-1px);
}

.btn-approve:disabled {
  background: #a8c8f0;
  cursor: not-allowed;
}

.btn-cancel {
  background: #d42f2f;
  color: white;
  padding: 10px 22px;
  border-radius: 6px;
  border: none;
  font-size: 15px;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.1s ease;
}

.btn-cancel:hover {
  background: #991c1c;
  transform: translateY(-1px);
}

.btn-cancel:disabled {
  background: #db7676;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/css/AllChats.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB,EAAE,4BAA4B;EAChD,gBAAgB,EAAE,4DAA4D;EAC9E,qDAAqD,EAAE,kCAAkC;EACzF,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,2CAA2C;EAC3C,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;AAC/D;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB,EAAE,0CAA0C;EAC/D,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,0CAA0C;EAC1C,8CAA8C,EAAE,sBAAsB;EACtE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,0CAA0C,EAAE,mCAAmC;AACjF;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa,EAAE,iBAAiB;AAClC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,yDAAyN;EACzN,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;;AAGA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB","sourcesContent":[".allchats-container {\n  display: flex;\n  height: 100vh;\n  background: #f8f9fa;\n  overflow: hidden;\n}\n\n.allchats-sidebar {\n  width: 300px;\n  padding: 20px;\n  position: relative; /* create stacking context */\n  overflow-y: auto; /* whole sidebar scrolls; pager flows right after the list */\n  background: linear-gradient(180deg, #232e47, #111733); /* match landing page left panel */\n  color: #ffffff;\n}\n\n.allchats-sidebar h4 {\n  margin-bottom: 20px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #ffffff;\n}\n\n/* Pagination — flows immediately after the list of builds. */\n.chat-pagination {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n  gap: 6px;\n  padding-top: 12px;\n  margin-top: 10px;\n  border-top: 1px solid rgba(255, 255, 255, 0.12);\n}\n\n.page-btn {\n  width: 28px;\n  height: 28px;\n  padding: 0;\n  border-radius: 50%;\n  border: 1px solid rgba(255, 255, 255, 0.25);\n  background: rgba(255, 255, 255, 0.08);\n  color: #e5e7eb;\n  font-size: 12px;\n  line-height: 1;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.15s, border-color 0.15s, color 0.15s;\n}\n\n.page-btn:hover:not(:disabled) {\n  background: #6366f1;\n  border-color: #6366f1;\n  color: #ffffff;\n}\n\n.page-btn.active {\n  background: #d1a054; /* gold accent (matches sidebar spinner) */\n  border-color: #d1a054;\n  color: #1a1a1a;\n  font-weight: 700;\n}\n\n.page-btn:disabled {\n  opacity: 0.35;\n  cursor: not-allowed;\n}\n\n.page-arrow {\n  font-size: 16px;\n}\n\n.page-ellipsis {\n  color: #cbd5e1;\n  padding: 0 2px;\n  font-size: 13px;\n  user-select: none;\n}\n\n.chat-item {\n  position: relative;\n  margin-bottom: 12px;\n  padding: 10px 14px;\n  border-radius: 12px;\n  background: #ffffff;\n  cursor: pointer;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);\n  transition: box-shadow 0.15s, background 0.15s; /* removed transform */\n  z-index: auto;\n}\n\n.chat-item:hover {\n  background: #e0e7ff;\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12); /* keep only shadow, no transform */\n}\n\n.chat-item.selected {\n  background: #c7d2fe;\n  border: 1px solid #6366f1;\n}\n\n.chat-main {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 13px;\n  color: #1e293b;\n}\n\n.pin-icon {\n  margin-right: 6px;\n  font-size: 14px;\n}\n\n.chat-options-btn {\n  /* background: #e0e0e0; */\n  border: none;\n  cursor: pointer;\n  width: 24px;\n  height: 24px;\n  border-radius: 6px;\n  font-size: 16px;\n  line-height: 1;\n}\n\n/* CHAT DROPDOWN */\n.chat-dropdown {\n  position: absolute;\n  top: 38px;\n  right: 0;\n  width: 200px;\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 16px 32px rgba(0, 0, 0, 0.15);\n  padding: 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  z-index: 9999; /* high z-index */\n}\n\n.chat-dropdown button {\n  background: #f1f5f9;\n  color: #1e293b;\n  border: none;\n  padding: 6px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 13px;\n  text-align: left;\n  transition: background 0.15s;\n}\n\n.chat-dropdown button:hover {\n  background: #e0e7ff;\n}\n\n.rename-input-container {\n  display: flex;\n  gap: 6px;\n}\n\n.rename-input-container input {\n  flex: 1;\n  padding: 6px 8px;\n  border-radius: 8px;\n  border: 1px solid #cbd5e1;\n  font-size: 13px;\n}\n\n.rename-input-container button {\n  padding: 6px 8px;\n  border-radius: 8px;\n  border: none;\n  background: #6366f1;\n  color: white;\n  cursor: pointer;\n}\n\n.allchats-main {\n  flex: 1;\n  padding: 20px;\n  overflow-y: auto;\n}\n.allchats-main h2 {\n  margin-bottom: 20px;\n  font-size: 18px;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0,0,0,0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.modal-content {\n  background: white;\n  padding: 25px;\n  border-radius: 8px;\n  width: 400px;\n  text-align: center;\n}\n\n.primary-btn {\n  background: #007bff;\n  color: white;\n  padding: 10px 18px;\n  border-radius: 6px;\n  margin: 10px;\n}\n\n.secondary-btn {\n  background: #ccc;\n  padding: 10px 18px;\n  border-radius: 6px;\n  margin: 10px;\n}\n\n/* Dropdown styling */\n.share-user-select {\n  width: 100%;\n  padding: 12px 14px;\n  border-radius: 8px;\n  border: 1px solid #d0d7de;\n  background: #fff;\n  font-size: 15px;\n  color: #333;\n  margin: 15px 0;\n  transition: all 0.2s ease;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml;utf8,<svg fill='gray' height='20' viewBox='0 0 20 20' width='20' xmlns='http://www.w3.org/2000/svg'><path d='M5.516 7.548l4.484 4.484 4.484-4.484L16 8.548l-6 6-6-6z'/></svg>\");\n  background-repeat: no-repeat;\n  background-position: right 12px center;\n}\n\n.share-user-select:hover {\n  border-color: #b6bec7;\n}\n\n.share-user-select:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25);\n}\n\n/* Button container */\n.share-modal-buttons {\n  display: flex;\n  justify-content: center;\n  gap: 12px;\n  margin-top: 20px;\n}\n\n/* Primary button */\n.btn-primary {\n  background: #007bff;\n  color: white;\n  padding: 10px 22px;\n  border-radius: 6px;\n  border: none;\n  font-size: 15px;\n  cursor: pointer;\n  transition: background 0.2s ease, transform 0.1s ease;\n}\n\n.btn-primary:hover {\n  background: #0069d9;\n  transform: translateY(-1px);\n}\n\n.btn-primary:disabled {\n  background: #a8c8f0;\n  cursor: not-allowed;\n}\n\n/* Secondary button */\n.btn-secondary {\n  background: #e4e7eb;\n  color: #333;\n  padding: 10px 22px;\n  border-radius: 6px;\n  border: none;\n  font-size: 15px;\n  cursor: pointer;\n  transition: background 0.2s ease, transform 0.1s ease;\n}\n\n.btn-secondary:hover {\n  background: #d4d7db;\n  transform: translateY(-1px);\n}\n\n\n.btn-approve {\n  background: #0a62c0;\n  color: white;\n  padding: 10px 22px;\n  border-radius: 6px;\n  border: none;\n  font-size: 15px;\n  cursor: pointer;\n  transition: background 0.2s ease, transform 0.1s ease;\n}\n\n.btn-approve:hover {\n  background: #0254ac;\n  transform: translateY(-1px);\n}\n\n.btn-approve:disabled {\n  background: #a8c8f0;\n  cursor: not-allowed;\n}\n\n.btn-cancel {\n  background: #d42f2f;\n  color: white;\n  padding: 10px 22px;\n  border-radius: 6px;\n  border: none;\n  font-size: 15px;\n  cursor: pointer;\n  transition: background 0.2s ease, transform 0.1s ease;\n}\n\n.btn-cancel:hover {\n  background: #991c1c;\n  transform: translateY(-1px);\n}\n\n.btn-cancel:disabled {\n  background: #db7676;\n  cursor: not-allowed;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
